/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2024) Takeda. All Rights Reserved
 */

import { CookieSetOptions } from 'universal-cookie';

import { getMainDomain } from '../browser.domain';
import { getCurrentDate } from '../dates/dates.domain';

export const getCookieOptions = (): CookieSetOptions => {
  const isLocalhost = isLocalhostHostname();

  const options: CookieSetOptions = {
    ...getBaseOptions(),
    expires: getExpiration(),
    path: '/',
  };

  // On localhost, setting a Domain attribute (e.g. ".localhost") is commonly rejected by browsers.
  // Also, Partitioned cookies require secure contexts, so we avoid them for local dev.
  if (!isLocalhost) {
    options.domain = getMainDomain();
    options.partitioned = true;
  }

  return options;
};

const getBaseOptions = (): Partial<CookieSetOptions> => {
  return isLocalhostHostname()
    ? { sameSite: 'lax', secure: false }
    : { sameSite: 'none', secure: true };
};

const isLocalhostHostname = (): boolean =>
  window.location.hostname === 'localhost';

const getExpiration = () => {
  const currentDate = getCurrentDate();
  currentDate.setFullYear(currentDate.getFullYear() + 1);
  return currentDate;
};
